import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useRouterListStore = defineStore('routerList', () => {
  let routerList = ref([]);

  let authenticatedList = ref(new Map());
  function setRouterList(list) {
    routerList.value = list;
  }
  function setAuthenticatedList(map) {
    authenticatedList.value = map;
  }

  return { routerList, setRouterList, authenticatedList, setAuthenticatedList };
});
